import React from 'react';
import './PromocionLayout.css';

function PromocionLayout({
  titulo = '¡Promoción Especial!',
  subtitulo = 'Descubre nuestra oferta exclusiva para hacer de tu evento algo inolvidable',
  children,
  ctaTitulo = '¿Listo para participar?',
  ctaSubtitulo = '¡No pierdas esta oportunidad única!',
  mostrarBotonesSociales = true,
}) {
  return (
    <div className="promocion-page">
      <div className="promocion-hero">
        <div className="promocion-hero-content">
          <h1>{titulo}</h1>
          <p>{subtitulo}</p>
        </div>
      </div>

      <div className="container">
        <div className="promocion-content">
          <section className="promocion-main">
            <div className="promocion-text">{children}</div>

            <div className="promocion-cta">
              <h3>{ctaTitulo}</h3>
              <p>{ctaSubtitulo}</p>

              {mostrarBotonesSociales && (
                <div className="social-buttons">
                  <a
                    href="https://www.facebook.com/procam360mx/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-social facebook"
                  >
                    <i className="fab fa-facebook-f"></i>
                    Seguir en Facebook
                  </a>
                  <a
                    href="https://instagram.com/procam360mx"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-social instagram"
                  >
                    <i className="fab fa-instagram"></i>
                    Seguir en Instagram
                  </a>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PromocionLayout;
